module.exports = __webpack_public_path__ + "img/close-eye.40125f14.svg";